import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/applicantlogin.css";
import "../assets/css/newstudent.css";
import Navbar from "../components/Navbar";

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction
  ? "https://schools.luth.gov.ng" || "https://10.0.0.57"
  : "http://localhost:3003";

const CLOSED_PROGRAMMES = [
  // "college of nursing sciences",
  // "neonatal nursing",
  // "perioperative nursing",
  // "accident & emergency",
  // "accident and emergency",
  // "paediatric nursing",
  // "ophthalmic nursing",
  // "nephrology nursing",
  // "critical care nursing",
  // "biomedical engineering (nd)",
  // "school of health information management (nd)",
  // "anaesthetic technician",
  // "biomedical engineering (hnd)",
  // "school of health information management (hnd)",
  // "medical and psychiatry social work",
];

const ApplicantLogin = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [programme, setProgramme] = useState("");
  const [loading, setLoading] = useState(false);

  // CLOSED modal state
  const [showClosedModal, setShowClosedModal] = useState(false);
  const [closedProgrammeName, setClosedProgrammeName] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE_URL}/api/applicant-login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });

      const data = await res.json();

      if (!res.ok) {
        alert(data.msg || "Invalid credentials");
        setLoading(false);
        return;
      }

      // Determine programme string returned by backend (safe fallback to empty)
      const rawProg = (data.programme || "").toString();
      const prog = rawProg.toLowerCase();

      // If programme matches any closed programme, block login and show modal
      const isClosed = CLOSED_PROGRAMMES.some(
        (closed) => prog === closed || prog.includes(closed),
      );
      if (isClosed) {
        setClosedProgrammeName(rawProg || "the selected programme");
        setShowClosedModal(true);
        setLoading(false);
        return; // do NOT persist or navigate
      }

      if (data.paymentStatus === "Pending") {
        setShowPaymentModal(true);
        setProgramme(data.programme);
        setLoading(false);
        return;
      }

      if (!res.ok) {
        if (res.status === 403) {
          setClosedProgrammeName(
            data.msg || "Can't login. The application session has closed.",
          );
          setShowClosedModal(true);
          setLoading(false);
          return;
        }

        alert(data.msg || "Invalid credentials");
        setLoading(false);
        return;
      }

      // Normal successful login: persist and navigate
      localStorage.setItem("email", email);
      localStorage.setItem("programme", data.programme);
      localStorage.setItem("appno", data.appno);

      if (data.hasBiodata) {
        localStorage.setItem("biodata", JSON.stringify(data.biodata));
      } else {
        localStorage.removeItem("biodata");
      }

      navigate("/biodata", { replace: true });
    } catch (err) {
      console.error("Login failed", err);
      alert("Login failed – please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Navbar />
      <div className="newstudents-wrapper">
        {/* Loading overlay */}
        {loading && (
          <div className="loading-overlay">
            <div className="spinner"></div>
          </div>
        )}

        <div className="subschool-title-banner">
          <h1 className="subschool-title">
            New Student <br /> Application Portal
          </h1>
        </div>

        <div className="applicant-login-page">
          <div className="app-login-form-container">
            <h2>Login to Complete Application</h2>
            <form className="login-form" onSubmit={handleLogin}>
              <input
                type="email"
                placeholder="Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
              <input
                type="password"
                placeholder="Generated Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              <button type="submit" disabled={loading}>
                {loading ? "Logging in..." : "Login"}
              </button>
              <div className="login-help-text">
                <p>
                  If you have any issues logging in, please contact the
                  applications office at{" "}
                  <a href="mailto:applications@luth.gov.ng">
                    applications@luth.gov.ng
                  </a>
                </p>
              </div>
            </form>
          </div>
        </div>

        {/* Payment modal */}
        {showPaymentModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>Payment Required</h2>
              <p>
                Your payment status is <strong>pending</strong>. Please proceed
                to make payment to continue.
              </p>
              {programme && (
                <p>
                  Programme: <strong>{programme}</strong>
                </p>
              )}
              <div className="payment-buttons">
                <a href="https://luth-school-payment.netlify.app/">
                  <button>Proceed to Payment</button>
                </a>
                <button onClick={() => setShowPaymentModal(false)}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}

        {/* CLOSED modal for blocked programmes */}
        {showClosedModal && (
          <div className="modal-overlay">
            <div className="modal-content">
              <h2>Unable to login</h2>
              <p>{closedProgrammeName}</p>
              <p>
                Contact School Admin on:
                <br />
                <strong>Schools Admin Official Line - 07053736974</strong>
              </p>

              <div style={{ marginTop: 12 }}>
                <button onClick={() => setShowClosedModal(false)}>Close</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApplicantLogin;
